import { useEffect } from 'react';

import { getIsAttendanceIntroductionSkipped } from '../../../../db/classes';

export interface UseIntroduction {
  goToNextStep: () => void;
}

const useIntroduction = ({ goToNextStep }: UseIntroduction) => {
  useEffect(() => {
    const skipIntroduction = getIsAttendanceIntroductionSkipped();

    if (!skipIntroduction) return;

    goToNextStep();
  }, []);
};

export default useIntroduction;
